// French translations of countries with ISO codes
export const countriesFR = [
  { code: "AF", label: "Afghanistan" },
  { code: "ZA", label: "Afrique du Sud" },
  { code: "AL", label: "Albanie" },
  { code: "DZ", label: "Algérie" },
  { code: "DE", label: "Allemagne" },
  { code: "AD", label: "Andorre" },
  { code: "AO", label: "Angola" },
  { code: "AI", label: "Anguilla" },
  { code: "AQ", label: "Antarctique" },
  { code: "AG", label: "Antigua-et-Barbuda" },
  { code: "SA", label: "Arabie Saoudite" },
  { code: "AR", label: "Argentine" },
  { code: "AM", label: "Arménie" },
  { code: "AW", label: "Aruba" },
  { code: "AU", label: "Australie" },
  { code: "AT", label: "Autriche" },
  { code: "AZ", label: "Azerbaïdjan" },
  { code: "BS", label: "Bahamas" },
  { code: "BH", label: "Bahreïn" },
  { code: "BD", label: "Bangladesh" },
  { code: "BB", label: "Barbade" },
  { code: "BE", label: "Belgique" },
  { code: "BZ", label: "Belize" },
  { code: "BJ", label: "Bénin" },
  { code: "BM", label: "Bermudes" },
  { code: "BT", label: "Bhoutan" },
  { code: "BY", label: "Biélorussie" },
  { code: "MM", label: "Birmanie" },
  { code: "BO", label: "Bolivie" },
  { code: "BA", label: "Bosnie-Herzégovine" },
  { code: "BW", label: "Botswana" },
  { code: "BR", label: "Brésil" },
  { code: "BN", label: "Brunei" },
  { code: "BG", label: "Bulgarie" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BI", label: "Burundi" },
  { code: "KH", label: "Cambodge" },
  { code: "CM", label: "Cameroun" },
  { code: "CA", label: "Canada" },
  { code: "CV", label: "Cap-Vert" },
  { code: "CL", label: "Chili" },
  { code: "CN", label: "Chine" },
  { code: "CY", label: "Chypre" },
  { code: "CO", label: "Colombie" },
  { code: "KM", label: "Comores" },
  { code: "CG", label: "Congo-Brazzaville" },
  { code: "CD", label: "Congo-Kinshasa" },
  { code: "KR", label: "Corée du Sud" },
  { code: "KP", label: "Corée du Nord" },
  { code: "CR", label: "Costa Rica" },
  { code: "CI", label: "Côte d'Ivoire" },
  { code: "HR", label: "Croatie" },
  { code: "CU", label: "Cuba" },
  { code: "DK", label: "Danemark" },
  { code: "DJ", label: "Djibouti" },
  { code: "DM", label: "Dominique" },
  { code: "EG", label: "Égypte" },
  { code: "AE", label: "Émirats arabes unis" },
  { code: "EC", label: "Équateur" },
  { code: "ER", label: "Érythrée" },
  { code: "ES", label: "Espagne" },
  { code: "EE", label: "Estonie" },
  { code: "SZ", label: "Eswatini" },
  { code: "US", label: "États-Unis" },
  { code: "ET", label: "Éthiopie" },
  { code: "FJ", label: "Fidji" },
  { code: "FI", label: "Finlande" },
  { code: "FR", label: "France" },
  { code: "GA", label: "Gabon" },
  { code: "GM", label: "Gambie" },
  { code: "GE", label: "Géorgie" },
  { code: "GH", label: "Ghana" },
  { code: "GI", label: "Gibraltar" },
  { code: "GR", label: "Grèce" },
  { code: "GD", label: "Grenade" },
  { code: "GL", label: "Groenland" },
  { code: "GP", label: "Guadeloupe" },
  { code: "GU", label: "Guam" },
  { code: "GT", label: "Guatemala" },
  { code: "GN", label: "Guinée" },
  { code: "GQ", label: "Guinée équatoriale" },
  { code: "GW", label: "Guinée-Bissau" },
  { code: "GY", label: "Guyana" },
  { code: "GF", label: "Guyane française" },
  { code: "HT", label: "Haïti" },
  { code: "HN", label: "Honduras" },
  { code: "HK", label: "Hong Kong" },
  { code: "HU", label: "Hongrie" },
  { code: "IN", label: "Inde" },
  { code: "ID", label: "Indonésie" },
  { code: "IQ", label: "Irak" },
  { code: "IR", label: "Iran" },
  { code: "IE", label: "Irlande" },
  { code: "IS", label: "Islande" },
  { code: "IL", label: "Israël" },
  { code: "IT", label: "Italie" },
  { code: "JM", label: "Jamaïque" },
  { code: "JP", label: "Japon" },
  { code: "JO", label: "Jordanie" },
  { code: "KZ", label: "Kazakhstan" },
  { code: "KE", label: "Kenya" },
  { code: "KG", label: "Kirghizistan" },
  { code: "KI", label: "Kiribati" },
  { code: "KW", label: "Koweït" },
  { code: "LA", label: "Laos" },
  { code: "LS", label: "Lesotho" },
  { code: "LV", label: "Lettonie" },
  { code: "LB", label: "Liban" },
  { code: "LR", label: "Libéria" },
  { code: "LY", label: "Libye" },
  { code: "LI", label: "Liechtenstein" },
  { code: "LT", label: "Lituanie" },
  { code: "LU", label: "Luxembourg" },
  { code: "MO", label: "Macao" },
  { code: "MK", label: "Macédoine du Nord" },
  { code: "MG", label: "Madagascar" },
  { code: "MY", label: "Malaisie" },
  { code: "MW", label: "Malawi" },
  { code: "MV", label: "Maldives" },
  { code: "ML", label: "Mali" },
  { code: "MT", label: "Malte" },
  { code: "MA", label: "Maroc" },
  { code: "MQ", label: "Martinique" },
  { code: "MU", label: "Maurice" },
  { code: "MR", label: "Mauritanie" },
  { code: "YT", label: "Mayotte" },
  { code: "MX", label: "Mexique" },
  { code: "FM", label: "Micronésie" },
  { code: "MD", label: "Moldavie" },
  { code: "MC", label: "Monaco" },
  { code: "MN", label: "Mongolie" },
  { code: "ME", label: "Monténégro" },
  { code: "MS", label: "Montserrat" },
  { code: "MZ", label: "Mozambique" },
  { code: "NA", label: "Namibie" },
  { code: "NR", label: "Nauru" },
  { code: "NP", label: "Népal" },
  { code: "NI", label: "Nicaragua" },
  { code: "NE", label: "Niger" },
  { code: "NG", label: "Nigéria" },
  { code: "NU", label: "Niue" },
  { code: "NO", label: "Norvège" },
  { code: "NC", label: "Nouvelle-Calédonie" },
  { code: "NZ", label: "Nouvelle-Zélande" },
  { code: "OM", label: "Oman" },
  { code: "UG", label: "Ouganda" },
  { code: "UZ", label: "Ouzbékistan" },
  { code: "PK", label: "Pakistan" },
  { code: "PW", label: "Palaos" },
  { code: "PS", label: "Palestine" },
  { code: "PA", label: "Panama" },
  { code: "PG", label: "Papouasie-Nouvelle-Guinée" },
  { code: "PY", label: "Paraguay" },
  { code: "NL", label: "Pays-Bas" },
  { code: "PE", label: "Pérou" },
  { code: "PH", label: "Philippines" },
  { code: "PN", label: "Pitcairn" },
  { code: "PL", label: "Pologne" },
  { code: "PF", label: "Polynésie française" },
  { code: "PR", label: "Porto Rico" },
  { code: "PT", label: "Portugal" },
  { code: "QA", label: "Qatar" },
  { code: "RE", label: "La Réunion" },
  { code: "RO", label: "Roumanie" },
  { code: "GB", label: "Royaume-Uni" },
  { code: "RU", label: "Russie" },
  { code: "RW", label: "Rwanda" },
  { code: "KN", label: "Saint-Kitts-et-Nevis" },
  { code: "SM", label: "Saint-Marin" },
  { code: "MF", label: "Saint-Martin" },
  { code: "SX", label: "Saint-Martin (partie néerlandaise)" },
  { code: "PM", label: "Saint-Pierre-et-Miquelon" },
  { code: "VC", label: "Saint-Vincent-et-les-Grenadines" },
  { code: "SH", label: "Sainte-Hélène" },
  { code: "LC", label: "Sainte-Lucie" },
  { code: "SV", label: "Salvador" },
  { code: "WS", label: "Samoa" },
  { code: "AS", label: "Samoa américaines" },
  { code: "ST", label: "Sao Tomé-et-Principe" },
  { code: "SN", label: "Sénégal" },
  { code: "RS", label: "Serbie" },
  { code: "SC", label: "Seychelles" },
  { code: "SL", label: "Sierra Leone" },
  { code: "SG", label: "Singapour" },
  { code: "SK", label: "Slovaquie" },
  { code: "SI", label: "Slovénie" },
  { code: "SO", label: "Somalie" },
  { code: "SD", label: "Soudan" },
  { code: "SS", label: "Soudan du Sud" },
  { code: "LK", label: "Sri Lanka" },
  { code: "SE", label: "Suède" },
  { code: "CH", label: "Suisse" },
  { code: "SR", label: "Suriname" },
  { code: "SY", label: "Syrie" },
  { code: "TJ", label: "Tadjikistan" },
  { code: "TW", label: "Taïwan" },
  { code: "TZ", label: "Tanzanie" },
  { code: "TD", label: "Tchad" },
  { code: "CZ", label: "Tchéquie" },
  { code: "TF", label: "Terres australes et antarctiques françaises" },
  { code: "TH", label: "Thaïlande" },
  { code: "TL", label: "Timor oriental" },
  { code: "TG", label: "Togo" },
  { code: "TK", label: "Tokelau" },
  { code: "TO", label: "Tonga" },
  { code: "TT", label: "Trinité-et-Tobago" },
  { code: "TN", label: "Tunisie" },
  { code: "TM", label: "Turkménistan" },
  { code: "TR", label: "Turquie" },
  { code: "TV", label: "Tuvalu" },
  { code: "UA", label: "Ukraine" },
  { code: "UY", label: "Uruguay" },
  { code: "VU", label: "Vanuatu" },
  { code: "VA", label: "Vatican" },
  { code: "VE", label: "Venezuela" },
  { code: "VN", label: "Viêt Nam" },
  { code: "WF", label: "Wallis-et-Futuna" },
  { code: "YE", label: "Yémen" },
  { code: "ZM", label: "Zambie" },
  { code: "ZW", label: "Zimbabwe" },
];

// Add phone codes to each country
const countriesWithPhoneCodes = countriesFR.map((country) => {
  // Define phone codes for each country
  const phoneCodeMap = {
    AF: "+93",
    ZA: "+27",
    AL: "+355",
    DZ: "+213",
    DE: "+49",
    AD: "+376",
    AO: "+244",
    AI: "+1-264",
    AQ: "+672",
    AG: "+1-268",
    SA: "+966",
    AR: "+54",
    AM: "+374",
    AW: "+297",
    AU: "+61",
    AT: "+43",
    AZ: "+994",
    BS: "+1-242",
    BH: "+973",
    BD: "+880",
    BB: "+1-246",
    BE: "+32",
    BZ: "+501",
    BJ: "+229",
    BM: "+1-441",
    BT: "+975",
    BY: "+375",
    MM: "+95",
    BO: "+591",
    BA: "+387",
    BW: "+267",
    BR: "+55",
    BN: "+673",
    BG: "+359",
    BF: "+226",
    BI: "+257",
    KH: "+855",
    CM: "+237",
    CA: "+1",
    CV: "+238",
    CL: "+56",
    CN: "+86",
    CY: "+357",
    CO: "+57",
    KM: "+269",
    CG: "+242",
    CD: "+243",
    KR: "+82",
    KP: "+850",
    CR: "+506",
    CI: "+225",
    HR: "+385",
    CU: "+53",
    DK: "+45",
    DJ: "+253",
    DM: "+1-767",
    EG: "+20",
    AE: "+971",
    EC: "+593",
    ER: "+291",
    ES: "+34",
    EE: "+372",
    SZ: "+268",
    US: "+1",
    ET: "+251",
    FJ: "+679",
    FI: "+358",
    FR: "+33",
    GA: "+241",
    GM: "+220",
    GE: "+995",
    GH: "+233",
    GI: "+350",
    GR: "+30",
    GD: "+1-473",
    GL: "+299",
    GP: "+590",
    GU: "+1-671",
    GT: "+502",
    GN: "+224",
    GQ: "+240",
    GW: "+245",
    GY: "+592",
    GF: "+594",
    HT: "+509",
    HN: "+504",
    HK: "+852",
    HU: "+36",
    IN: "+91",
    ID: "+62",
    IQ: "+964",
    IR: "+98",
    IE: "+353",
    IS: "+354",
    IL: "+972",
    IT: "+39",
    JM: "+1-876",
    JP: "+81",
    JO: "+962",
    KZ: "+7",
    KE: "+254",
    KG: "+996",
    KI: "+686",
    KW: "+965",
    LA: "+856",
    LS: "+266",
    LV: "+371",
    LB: "+961",
    LR: "+231",
    LY: "+218",
    LI: "+423",
    LT: "+370",
    LU: "+352",
    MO: "+853",
    MK: "+389",
    MG: "+261",
    MY: "+60",
    MW: "+265",
    MV: "+960",
    ML: "+223",
    MT: "+356",
    MA: "+212",
    MQ: "+596",
    MU: "+230",
    MR: "+222",
    YT: "+262",
    MX: "+52",
    FM: "+691",
    MD: "+373",
    MC: "+377",
    MN: "+976",
    ME: "+382",
    MS: "+1-664",
    MZ: "+258",
    NA: "+264",
    NR: "+674",
    NP: "+977",
    NI: "+505",
    NE: "+227",
    NG: "+234",
    NU: "+683",
    NO: "+47",
    NC: "+687",
    NZ: "+64",
    OM: "+968",
    UG: "+256",
    UZ: "+998",
    PK: "+92",
    PW: "+680",
    PS: "+970",
    PA: "+507",
    PG: "+675",
    PY: "+595",
    NL: "+31",
    PE: "+51",
    PH: "+63",
    PN: "+64",
    PL: "+48",
    PF: "+689",
    PR: "+1-787",
    PT: "+351",
    QA: "+974",
    RE: "+262",
    RO: "+40",
    GB: "+44",
    RU: "+7",
    RW: "+250",
    KN: "+1-869",
    SM: "+378",
    MF: "+590",
    SX: "+1-721",
    PM: "+508",
    VC: "+1-784",
    SH: "+290",
    LC: "+1-758",
    SV: "+503",
    WS: "+685",
    AS: "+1-684",
    ST: "+239",
    SN: "+221",
    RS: "+381",
    SC: "+248",
    SL: "+232",
    SG: "+65",
    SK: "+421",
    SI: "+386",
    SO: "+252",
    SD: "+249",
    SS: "+211",
    LK: "+94",
    SE: "+46",
    CH: "+41",
    SR: "+597",
    SY: "+963",
    TJ: "+992",
    TW: "+886",
    TZ: "+255",
    TD: "+235",
    CZ: "+420",
    TF: "+262",
    TH: "+66",
    TL: "+670",
    TG: "+228",
    TK: "+690",
    TO: "+676",
    TT: "+1-868",
    TN: "+216",
    TM: "+993",
    TR: "+90",
    TV: "+688",
    UA: "+380",
    UY: "+598",
    VU: "+678",
    VA: "+39-06",
    VE: "+58",
    VN: "+84",
    WF: "+681",
    YE: "+967",
    ZM: "+260",
    ZW: "+263",
  };

  return {
    ...country,
    phone: phoneCodeMap[country.code] || "+" + country.code,
  };
});

export default countriesWithPhoneCodes;
